<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" backdrop shadow :visible="!!accidentID" :right="true"
            no-header-close no-close-on-backdrop no-close-on-esc>
            <template #header="{ }">
                <div class="d-flex align-items-center w-100 justify-content-between">
                    <div class="d-flex align-items-center w-100 mr-2">
                        <div class="text-nowrap" v-if="currentAccidentData">
                            {{ currentAccidentData.record_no }}
                        </div>
                        <!-- <b-button class="ml-5 pe-none d-flex justify-content-center align-items-center w-100px h-40px"
                            :class="accidentPayload.status === 'New'
                                ? 'new-record'
                                : accidentPayload.status === 'Urgent'
                                    ? 'urgent-record text-white'
                                    : accidentPayload.status === 'Open' ? 'open-record' : 'inactive-equipment text-black'"
                            :variant="accidentPayload.status === 'New' ? 'warning' : accidentPayload.status === 'Urgent' ? 'danger' : accidentPayload.status === 'Open' ? 'success' : 'light'">
                            <p class="mb-0">{{ accidentPayload.status }}</p>
                        </b-button> -->
                    </div>
                    <b-dropdown id="dropdown-divider" text="text" class="load-dropdown mt-0" v-if="allowDeleteRecord">
                        <template slot="button-content">
                            <b-icon class="dots" icon="three-dots"></b-icon>
                        </template>
                        <b-dropdown-item-button @click="showDeleteAccidentModal = true">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editAccident.delete') }}</p>
                        </b-dropdown-item-button>
                    </b-dropdown>
                </div>
            </template>
            <div class="body" v-if="currentAccidentData">
                <div class="sidebar-tabs">
                    <div class="bg-white rounded">
                        <v-tabs class="team-tabs mb-0" v-model="activeTab" show-arrows>
                            <v-tab key='info'>{{ $t('editAccident.infoTab') }}</v-tab>
                            <v-tab key='vehicles'>{{ $t('editAccident.vehiclesTab') }}</v-tab>
                            <v-tab key='contacts'>{{ $t('editAccident.contactsTab') }}</v-tab>
                            <v-tab key='images'>{{ $t('editAccident.imagesTab') }}</v-tab>
                            <v-tab key='documents'>{{ $t('editAccident.documentsTab') }}</v-tab>
                            <v-tab key='costs'>{{ $t('editAccident.costsTab') }}</v-tab>
                            <v-tab key='notes'>{{ $t('editAccident.notesTab') }}</v-tab>
                            <v-tab key='activity' v-if="showActivitySection">{{ $t('editAccident.activityTab') }}</v-tab>
                        </v-tabs>
                    </div>
                </div>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item key='info'>
                        <hr class="mt-0" />
                        <div class="d-block text-center mt-4rem">
                            <b-row class="align-items-center px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('editAccident.basicSection') }}</h3>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('addAccident.recordLabel')" class="text-left mb-0">
                                        <b-form-input v-model="currentAccidentData.record_no" disabled type="text"
                                            :placeholder="$t('addAccident.recordPlaceholder')" class="unit" required></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addAccident.statusLabel') }}</label>
                                        <b-form-select v-model="accidentPayload.status" :disabled="!allowUpdateRecord"
                                            class="f-12" :options="statusOptions" />
                                    </div>
                                </b-col>
                                <b-col sm="12" class="mt-3 text-left">
                                    <label for="accident-edit-datepicker" class="state">{{ $t('addAccident.dateLabel') }}</label>
                                    <date-picker v-model="accidentPayload.date" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="accidentPayload.date = ''"
                                        :placeholder="$t('editAccident.selectDate')" class="date-picker-custom" :disabled="!allowUpdateRecord"
                                        :teleport="'body'"></date-picker>
                                    <p v-if="errors && errors.date" class="field-error">
                                        {{ errors.date[0] }}
                                    </p>
                                </b-col>
                                <b-col sm="12" class="mt-3 text-left">
                                    <label class="state">{{ $t('addAccident.timeLabel') }}</label>
                                    <b-form-input type="time" class="f-12" :disabled="!allowUpdateRecord"
                                        v-model="accidentPayload.time"></b-form-input>
                                </b-col>
                                <b-col sm="12">
                                    <hr class="mt-4" />
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addAccident.driverLabel') }}</label>
                                        <v-select class="bg_white w-100 f-12" :disabled="!allowUpdateRecord"
                                            v-model="accidentPayload.driver" :options="driverOptions" item-value="id"
                                            item-text="label" :reduce="(option) => option.id" @search="searchDriver">
                                            <span slot="no-options">
                                                {{ $t('addAccident.searchDriver') }}
                                            </span>
                                        </v-select>
                                        <p v-if="errors && errors.driver" class="field-error">
                                            {{ errors.driver[0] }}
                                        </p>
                                    </div>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addAccident.vehicleLabel') }}</label>
                                        <v-select class="bg_white w-100 f-12" :disabled="!allowUpdateRecord"
                                            v-model="accidentPayload.vehicle" :options="vehicleOptions" item-value="id"
                                            item-text="label" :reduce="(option) => option.id" @search="searchVehicle">
                                            <span slot="no-options">
                                                {{ $t('addAccident.searchVehicle') }}
                                            </span>
                                        </v-select>
                                    </div>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addAccident.trailerLabel') }}</label>
                                        <v-select class="bg_white w-100 f-12" :disabled="!allowUpdateRecord"
                                            v-model="accidentPayload.trailer" :options="trailerOptions" item-value="id"
                                            item-text="label" :reduce="(option) => option.id" @search="searchTrailer">
                                            <span slot="no-options">
                                                {{ $t('addAccident.searchTrailer') }}
                                            </span>
                                        </v-select>
                                    </div>
                                </b-col>
                                <b-col sm="12">
                                    <hr class="mt-4" />
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addAccident.divisionLabel') }}</label>
                                        <v-select class="f-12" :clearable="false" :options="allDivisions"
                                            v-model="accidentPayload.division" :reduce="(option) => option.id" />
                                    </div>
                                </b-col>
                                <b-col sm="12">
                                     <hr class="mt-4" />
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addAccident.dotLabel') }}</label>
                                        <b-form-select v-model="accidentPayload.dot_status" :disabled="!allowUpdateRecord"
                                            class="f-12" :options="yesNoOptions" />
                                    </div>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <div class="text-left select_arrow">
                                        <label class="state">{{ $t('addAccident.faultLabel') }}</label>
                                        <b-form-select v-model="accidentPayload.fault_status" :disabled="!allowUpdateRecord"
                                            class="f-12" :options="yesNoOptions" />
                                    </div>
                                </b-col>
                                <b-col md="12" class="text-left mt-3">
                                    <label class="state text-left">{{ $t('addAccident.notesLabel') }}</label>
                                    <b-form-textarea id="textarea" :disabled="!allowUpdateRecord" :placeholder="$t('addAccident.notesPlaceholder')"
                                        rows="5" v-model="accidentPayload.notes" class="f-12"></b-form-textarea>
                                    <!-- <div class="text-right">
                                        <b-button class="mx-0 mb-0 h-40px mt-3" variant="primary">Generate
                                            Drawing</b-button>
                                    </div> -->
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.claimsSection') }}</h3>
                                <b-col md="12" sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.claimsLabel') }}</label>
                                    <v-select class="bg_white w-100 f-12" :disabled="!allowUpdateRecord" multiple
                                        v-model="claimNumbers" :options="claimOptions" item-value="id" item-text="label"
                                        :reduce="(option) => option.id" @search="searchClaims">
                                        <span slot="no-options">
                                            {{ $t('addAccident.searchClaim') }}
                                        </span>
                                    </v-select>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.locationSection') }}</h3>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.addressLabel') }}</label>
                                    <b-form-input v-model="accidentPayload.address" class="f-12"
                                        :placeholder="$t('addAccident.addressPlaceholder')"></b-form-input>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.cityLabel') }}</label>
                                    <b-form-input v-model="accidentPayload.city" class="f-12"
                                        :placeholder="$t('addAccident.cityPlaceholder')"></b-form-input>
                                </b-col>
                                <b-col sm="12">
                                    <div class="text-left select_arrow mt-3">
                                        <label class="state">{{ $t('addAccident.stateLabel') }}</label>
                                        <v-select class="bg_white w-100 f-12" v-model="accidentPayload.state"
                                            :options="states" item-value="id" item-text="label"
                                            :reduce="(option) => option.id">
                                        </v-select>
                                    </div>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.postalCodeLabel') }}</label>
                                    <b-form-input v-model="accidentPayload.postal_code" class="f-12"
                                        :placeholder="$t('addAccident.postalCodePlaceholder')"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row class="px-4 my-3 position-relative">
                                <svg v-if="accidentPayload.drawing_data" class="accident-img-edit"
                                    @click="$bvModal.show('modal-drawing-accident')" width="30" height="30"
                                    viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="30" height="30" rx="8" fill="#F5F5F5" />
                                    <path
                                        d="M12.4801 21.575L19.7753 14.2798L16.3102 10.8147L9.01503 18.1099C8.9146 18.2105 8.84325 18.3363 8.80857 18.4742L8 22.59L12.1151 21.7814C12.2532 21.7469 12.3796 21.6755 12.4801 21.575ZM22.1303 11.9248C22.4247 11.6303 22.59 11.2311 22.59 10.8147C22.59 10.3984 22.4247 9.99915 22.1303 9.70472L20.8853 8.45969C20.5909 8.16535 20.1916 8 19.7753 8C19.3589 8 18.9597 8.16535 18.6652 8.45969L17.4202 9.70472L20.8853 13.1698L22.1303 11.9248Z"
                                        fill="#2CCE89" />
                                </svg>

                                <div class="drawing-section">
                                    <img :src="accidentPayload.drawing_data.image" v-if="accidentPayload.drawing_data"
                                        class="w-100 h-100" />
                                </div>
                                <div class="ml-auto pr-3">
                                    <b-button class="mx-0 h-40px mt-3" variant="primary"
                                        @click="$bvModal.show('modal-drawing-accident')"
                                        v-if="!accidentPayload.drawing_data">{{ $t('addAccident.drawAccident') }}</b-button>
                                </div>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.detailsSection') }}</h3>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.numVehiclesLabel') }}</label>
                                    <b-form-input v-model="accidentPayload.number_of_vehicles" class="f-12"
                                        :placeholder="$t('addAccident.numVehiclesPlaceholder')"></b-form-input>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.hazmatLabel') }}</label>
                                    <b-form-select v-model="accidentPayload.hazmat_or_gas_spill" class="f-12" :options="hazmatOptions" />
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.surfaceLabel') }}</label>
                                    <b-form-select v-model="accidentPayload.surface" class="f-12" :options="surfaceOptions" />
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.weatherLabel') }}</label>
                                    <b-form-select v-model="accidentPayload.weather" class="f-12" :options="weatherOptions" />
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.numInjuryLabel') }}</label>
                                    <b-form-input v-model="accidentPayload.number_of_injury" class="f-12"
                                        :placeholder="$t('addAccident.numInjuryPlaceholder')"></b-form-input>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label class="state">{{ $t('addAccident.numFatalityLabel') }}</label>
                                    <b-form-input v-model="accidentPayload.number_of_fatality" class="f-12"
                                        :placeholder="$t('addAccident.numFatalityPlaceholder')"></b-form-input>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.officerSection') }}</h3>
                                <b-col sm="12" class="text-left mb-2">
                                    <b-row>
                                        <b-col sm="12" class="text-left">
                                            <label>{{ $t('editAccident.yesLabel') }}</label>
                                            <b-form-checkbox name="check-button" class="ml-0-6rem"
                                                v-model="accidentPayload.officer_on_site" switch
                                                size="lg"></b-form-checkbox>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="12" v-if="accidentPayload.officer_on_site">
                                    <b-row>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.reportLabel') }}</label>
                                            <b-form-input v-model="accidentPayload.report_number" class="f-12"
                                                :placeholder="$t('addAccident.reportPlaceholder')"></b-form-input>
                                        </b-col>
                                        <b-col sm="12">
                                            <div class="text-left select_arrow mt-3">
                                                <label class="state">{{ $t('addAccident.stateLabel') }}</label>
                                                <v-select class="bg_white w-100 f-12" v-model="accidentPayload.report_state"
                                                    :options="states" item-value="id" item-text="label"
                                                    :reduce="(option) => option.id">
                                                </v-select>
                                            </div>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.citationIssuedLabel') }}</label>
                                            <b-form-select v-model="accidentPayload.citation_issues" class="f-12" :options="citationOptions" />
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.citationNumberLabel') }}</label>
                                            <b-form-input v-model="accidentPayload.citation_number" class="f-12"
                                                :placeholder="$t('addAccident.citationNumberPlaceholder')"></b-form-input>
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.ambulanceSection') }}</h3>
                                <b-col sm="12" class="text-left mb-2">
                                    <b-row>
                                        <b-col sm="12" class="text-left">
                                            <label>{{ $t('editAccident.yesLabel') }}</label>
                                            <b-form-checkbox name="check-button" class="ml-0-6rem"
                                                v-model="accidentPayload.ambulance_on_site" switch
                                                size="lg"></b-form-checkbox>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="12" v-if="accidentPayload.ambulance_on_site">
                                    <b-row>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.nameLabel') }}</label>
                                            <b-form-input v-model="accidentPayload.ambulance_name" class="f-12"
                                                :placeholder="$t('addAccident.namePlaceholder')"></b-form-input>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.locationLabel') }}</label>
                                            <b-form-input v-model="accidentPayload.ambulance_location" class="f-12"
                                                :placeholder="$t('addAccident.locationPlaceholder')"></b-form-input>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.driverTreatedLabel') }}</label>
                                            <b-form-select v-model="accidentPayload.driver_treated_by_ambulance"
                                                class="f-12" :options="yesNoNullOptions" />
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3"
                                            v-if="accidentPayload.driver_treated_by_ambulance === true">
                                            <label class="state">{{ $t('addAccident.wasFatalityLabel') }}</label>
                                            <b-form-select v-model="accidentPayload.is_fatality" class="f-12" :options="yesNoNullOptions" />
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.towingSection') }}</h3>
                                <b-col sm="12" class="text-left mb-2">
                                    <b-row>
                                        <b-col sm="12" class="text-left">
                                            <label>{{ $t('editAccident.yesLabel') }}</label>
                                            <b-form-checkbox name="check-button" class="ml-0-6rem"
                                                v-model="accidentPayload.towing" switch size="lg"></b-form-checkbox>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="12" v-if="accidentPayload.towing">
                                    <b-row>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.nameLabel') }}</label>
                                            <b-form-input v-model="accidentPayload.towing_name" class="f-12"
                                                :placeholder="$t('addAccident.namePlaceholder')"></b-form-input>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.locationLabel') }}</label>
                                            <b-form-input v-model="accidentPayload.towing_location" class="f-12"
                                                :placeholder="$t('addAccident.locationPlaceholder')"></b-form-input>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.vehicleTowedLabel') }}</label>
                                            <b-form-select v-model="accidentPayload.vehicle_towed" class="f-12" :options="yesNoNullOptions" />
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.loadedTrailerSection') }}</h3>
                                <b-col sm="12" class="text-left mb-2">
                                    <b-row>
                                        <b-col sm="12" class="text-left">
                                            <label>{{ $t('editAccident.yesLabel') }}</label>
                                            <b-form-checkbox name="check-button" class="ml-0-6rem"
                                                v-model="accidentPayload.loaded_trailer" switch size="lg"></b-form-checkbox>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="12" v-if="accidentPayload.loaded_trailer">
                                    <b-row>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.customerLabel') }}</label>
                                            <b-form-input v-model="accidentPayload.customer" class="f-12"
                                                :placeholder="$t('addAccident.customerPlaceholder')"></b-form-input>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.loadNumberLabel') }}</label>
                                            <b-form-input v-model="accidentPayload.load_number" class="f-12"
                                                :placeholder="$t('addAccident.loadNumberPlaceholder')"></b-form-input>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.loadDamagedLabel') }}</label>
                                            <b-form-select v-model="accidentPayload.load_damaged" class="f-12" :options="yesNoNullOptions" />
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4 mb-7rem">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addAccident.drugAlcSection') }}</h3>
                                <b-col sm="12" class="text-left mb-2">
                                    <b-row>
                                        <b-col sm="12" class="text-left">
                                            <label>{{ $t('editAccident.yesLabel') }}</label>
                                            <b-form-checkbox name="check-button" class="ml-0-6rem"
                                                v-model="accidentPayload.drug_or_alc" switch size="lg"></b-form-checkbox>
                                        </b-col>
                                    </b-row>
                                </b-col>
                                <b-col sm="12" v-if="accidentPayload.drug_or_alc">
                                    <b-row>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label for="drug-test-add-datepicker" class="state">{{ $t('addAccident.drugTestLabel') }}</label>
                                            <date-picker v-model="accidentPayload.drug_test_date" :formatter="momentFormat"
                                                :range-separator="' - '" @clear="accidentPayload.drug_test_date = ''"
                                                :placeholder="$t('editAccident.selectDate')" class="date-picker-custom"
                                                :teleport="'body'"></date-picker>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.statusLabel') }}</label>
                                            <b-form-select v-model="accidentPayload.drug_test_status" class="f-12" :options="drugStatusOptions" />
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label for="alc-add-datepicker" class="state">{{ $t('addAccident.alcTestLabel') }}</label>
                                            <date-picker v-model="accidentPayload.alc_test_date" :formatter="momentFormat"
                                                :range-separator="' - '" @clear="accidentPayload.alc_test_date = ''"
                                                :placeholder="$t('editAccident.selectDate')" class="date-picker-custom"
                                                :teleport="'body'"></date-picker>
                                        </b-col>
                                        <b-col sm="12" class="text-left mt-3">
                                            <label class="state">{{ $t('addAccident.statusLabel') }}</label>
                                            <b-form-select v-model="accidentPayload.alc_test_status" class="f-12" :options="drugStatusOptions" />
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                        </div>
                    </v-tab-item>
                    <v-tab-item key='vehicles'>
                        <div class="d-block body">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editAccident.vehiclesTab') }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    @click='$bvModal.show("modal-accident-vehicle")' v-if="allowUpdateRecord">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editAccident.addVehicle') }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="px-4">
                            <div v-if="vehicleItems.length === 0"
                                class="text-center text-muted py-4 bg-white rounded document-card-empty">
                                {{ $t('editAccident.noVehicles') }}
                            </div>
                            <div class="document-cards-list">
                                <div v-for="item in vehicleItems" :key="item.id" class="document-card">
                                    <div class="document-card-top">
                                        <span class="document-card-title">{{ item.name || '-' }}</span>
                                        <span class="document-card-date">
                                            {{ item.tow === true ? $t('accidentVehicle.towed') : item.tow === false ? $t('accidentVehicle.notTowed') : '-' }}
                                        </span>
                                    </div>
                                    <div class="document-card-divider"></div>
                                    <div class="info-card-meta">
                                        <span class="info-card-stat">{{ $t('accidentVehicle.makeLabel') }} <strong>{{ item.make || '-' }}</strong></span>
                                        <span class="info-card-stat">{{ $t('accidentVehicle.typeLabel') }} <strong>{{ item.type || '-' }}</strong></span>
                                        <span class="info-card-stat">{{ $t('accidentVehicle.insuranceLabel') }} <strong>{{ item.insurance || '-'
                                        }}</strong></span>
                                        <span class="info-card-stat">{{ $t('accidentVehicle.policyLabel') }} <strong>{{ item.policy_no || '-'
                                        }}</strong></span>
                                    </div>
                                    <div class="document-card-divider"></div>
                                    <div class="document-card-bottom justify-content-end">
                                        <div class="document-card-actions">
                                            <svg @click="setVehicleData(item)" class="cursor-pointer" width="21" height="21"
                                                viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7.9452 17.9664L1.71484 19.7109L3.45934 13.4806L14.8678 2.12751C14.9967 1.99564 15.1508 1.89086 15.3207 1.81932C15.4907 1.74779 15.6733 1.71094 15.8578 1.71094C16.0422 1.71094 16.2248 1.74779 16.3948 1.81932C16.5647 1.89086 16.7188 1.99564 16.8477 2.12751L19.2983 4.59196C19.428 4.72066 19.531 4.87381 19.6014 5.04251C19.6717 5.21123 19.7078 5.3922 19.7078 5.57497C19.7078 5.75774 19.6717 5.93871 19.6014 6.10743C19.531 6.27615 19.428 6.42928 19.2983 6.55798L7.9452 17.9664Z"
                                                    stroke="#2CCE89" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                            <svg v-if="allowUpdateRecord" @click="setDeleteVehicleData(item.id)"
                                                class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20"
                                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path
                                                    d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key='contacts'>
                        <div class="d-block body">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editAccident.contactsTab') }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    @click='$bvModal.show("modal-contact")' v-if="allowUpdateRecord">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editAccident.addContact') }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="px-4">
                            <div v-if="contactItems.length === 0"
                                class="text-center text-muted py-4 bg-white rounded document-card-empty">
                                {{ $t('editAccident.noContacts') }}
                            </div>
                            <div class="document-cards-list">
                                <div v-for="item in contactItems" :key="item.id" class="document-card">
                                    <div class="document-card-top">
                                        <span class="document-card-title">{{ item.name || '-' }}</span>
                                        <span class="document-card-date">{{ item.role || '-' }}</span>
                                    </div>
                                    <div class="document-card-divider"></div>
                                    <div class="info-card-meta">
                                        <span class="info-card-stat">{{ $t('safetyContacts.phoneLabel') }} <strong>{{ item.phone || '-' }}</strong></span>
                                        <span class="info-card-stat">{{ $t('safetyContacts.emailLabel') }} <strong>{{ item.email || '-' }}</strong></span>
                                        <span class="info-card-stat">{{ $t('safetyContacts.injFatLabel') }}
                                            <strong>
                                                {{ item.injury_status === "INJ" ? $t('safetyContacts.injury') : item.injury_status === "FAT"
                                                    ? $t('safetyContacts.fatality') : '-' }}
                                            </strong>
                                        </span>
                                        <span class="info-card-stat">{{ $t('safetyContacts.amblLabel') }}
                                            <strong>
                                                {{ item.ambulance === true ? $t('safetyContacts.yes') : item.ambulance === false ? $t('safetyContacts.no') : '-'
                                                }}
                                            </strong>
                                        </span>
                                    </div>
                                    <div class="document-card-divider"></div>
                                    <div class="document-card-bottom justify-content-end">
                                        <div class="document-card-actions">
                                            <svg @click="setContactData(item)" class="cursor-pointer" width="21" height="21"
                                                viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7.9452 17.9664L1.71484 19.7109L3.45934 13.4806L14.8678 2.12751C14.9967 1.99564 15.1508 1.89086 15.3207 1.81932C15.4907 1.74779 15.6733 1.71094 15.8578 1.71094C16.0422 1.71094 16.2248 1.74779 16.3948 1.81932C16.5647 1.89086 16.7188 1.99564 16.8477 2.12751L19.2983 4.59196C19.428 4.72066 19.531 4.87381 19.6014 5.04251C19.6717 5.21123 19.7078 5.3922 19.7078 5.57497C19.7078 5.75774 19.6717 5.93871 19.6014 6.10743C19.531 6.27615 19.428 6.42928 19.2983 6.55798L7.9452 17.9664Z"
                                                    stroke="#2CCE89" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                            <svg v-if="allowUpdateRecord" @click="setDeleteContactData(item.id)"
                                                class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20"
                                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path
                                                    d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key='images'>
                        <div class="d-block body">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editAccident.imagesTab') }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    @click='$refs.imgSection.openImageSection();' v-if="allowUpdateRecord">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editAccident.addImage') }}</p>
                                </div>
                            </div>
                            <ImagesSection ref="imgSection" :setActionImageData="setActionImageData"
                                :updateImg="updateAccidentDoc" :addImageFiles="addAccidentDoc" :id="accidentID"
                                :imageItems="imageItems" @updateImages="getImagesData"
                                :deleteImageFile="deleteAccidentDocument" />
                        </div>
                    </v-tab-item>
                    <v-tab-item key='documents'>
                        <div class="d-block body mb-7rem">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editAccident.documentsTab') }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    v-if="allowUpdateRecord" @click="$bvModal.show('modal-document')">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editAccident.addDocument') }}</p>
                                </div>
                            </div>
                            <div class="px-4">
                                <div v-if="documentItems.length === 0"
                                    class="text-center text-muted py-4 bg-white rounded document-card-empty">
                                    {{ $t('editAccident.noDocuments') }}
                                </div>
                                <div class="document-cards-list">
                                    <div v-for="item in documentItems" :key="item.pk" class="document-card">
                                        <div class="document-card-top">
                                            <span class="document-card-title">
                                                {{ item.description && item.description !== 'null' ? item.description :
                                                    '-' }}
                                            </span>
                                            <span class="document-card-date">
                                                {{ item.date || '-' }}
                                            </span>
                                        </div>
                                        <div class="document-card-divider"></div>
                                        <div class="document-card-bottom justify-content-end">
                                            <div class="document-card-actions">
                                                <svg @click="setDocumentData(item)" class="cursor-pointer" width="20"
                                                    height="15" viewBox="0 0 20 15" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path
                                                        d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                                                        stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg @click="downloadDoc(item)" class="cursor-pointer" width="20"
                                                    height="20" viewBox="0 0 20 20" fill="none"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822"
                                                        stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M10.0001 14.8497V5.15741" stroke="#FFC800" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                                                        stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <svg v-if="allowUpdateRecord" @click="setDeleteDocumentData(item.id)"
                                                    class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20"
                                                    fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path
                                                        d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path
                                                        d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                        stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                    <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                        stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key='costs'>
                        <div class="d-block body">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editAccident.costsTab') }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    @click='$bvModal.show("modal-cost")' v-if="allowUpdateRecord">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editAccident.addCost') }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="px-4">
                            <div v-if="costItems.length === 0"
                                class="text-center text-muted py-4 bg-white rounded document-card-empty">
                                {{ $t('editAccident.noCosts') }}
                            </div>
                            <div class="document-cards-list">
                                <div v-for="item in costItems" :key="item.id" class="document-card">
                                    <div class="document-card-top">
                                        <span class="document-card-title">
                                            {{ item.description && item.description !== 'null' ? item.description : '-'
                                            }}
                                        </span>
                                        <span class="document-card-date">{{ item.date || '-' }}</span>
                                    </div>
                                    <div class="document-card-divider"></div>
                                    <div class="document-card-bottom">
                                        <span class="info-card-amount">
                                            {{ item.amount ? '$' + item.amount : '-' }}
                                        </span>
                                        <div class="document-card-actions">
                                            <svg @click="setCostData(item)" class="cursor-pointer" width="21" height="21"
                                                viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M7.9452 17.9664L1.71484 19.7109L3.45934 13.4806L14.8678 2.12751C14.9967 1.99564 15.1508 1.89086 15.3207 1.81932C15.4907 1.74779 15.6733 1.71094 15.8578 1.71094C16.0422 1.71094 16.2248 1.74779 16.3948 1.81932C16.5647 1.89086 16.7188 1.99564 16.8477 2.12751L19.2983 4.59196C19.428 4.72066 19.531 4.87381 19.6014 5.04251C19.6717 5.21123 19.7078 5.3922 19.7078 5.57497C19.7078 5.75774 19.6717 5.93871 19.6014 6.10743C19.531 6.27615 19.428 6.42928 19.2983 6.55798L7.9452 17.9664Z"
                                                    stroke="#2CCE89" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                            <svg v-if="allowUpdateRecord" @click="setDeleteCostData(item.id)"
                                                class="cursor-pointer" width="19" height="20" viewBox="0 0 19 20"
                                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path
                                                    d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path
                                                    d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                    stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                    stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="costItems.length" class="info-card-total">
                                <span class="info-card-total-label">{{ $t('editAccident.total') }}</span>
                                <span class="info-card-total-value">
                                    {{ totalCostAmount ? `$${getAmount(totalCostAmount)}` : '-' }}
                                </span>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key="notes">
                        <div class="mt-4rem">
                            <Notes :key="currentAccidentData.id"
                                :noteURL="'app/safety-accidents/' + currentAccidentData.id + '/note'"
                                :allowUpdate="allowUpdateRecord" @updateNotes="$emit('accidentUpdated', true)" />
                        </div>
                    </v-tab-item>
                    <v-tab-item key="activity">
                        <div class="mt-4rem mb-6rem" v-if="showActivitySection">
                            <ActivityLogs :record="currentAccidentData.record_no" :object_id="currentAccidentData.id"
                                :key="currentAccidentData.id" />
                        </div>
                    </v-tab-item>
                </v-tabs-items>
                <div class="sidebar-footer position-fixed">
                    <div class="d-flex align-items-center justify-content-end">
                        <div class="text-right modal-footer border-0 p-0">
                            <b-button class="mx-0 h-40px w-100px m-0" :class="hasChanged && allowUpdateRecord ? 'mr-3' : ''"
                                @click="resetPopup()" variant="secondary">{{ $t('editAccident.close') }}</b-button>
                            <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="onUpdateAccident()"
                                v-if="hasChanged && allowUpdateRecord">{{ $t('editAccident.save') }}</b-button>
                        </div>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <Contacts @contactUpdated="getContactData" :id="accidentID" :contactData="contactData"
            @popupClose="contactData = null" :addContact="addAccidentContact" :updateContact="updateAccidentContact"
            :allowUpdateRecord="allowUpdateRecord" :accidentalContact="true" />
        <AccidentVehicle @vehicleUpdated="getVehicleData" :id="accidentID" :vehicleData="vehicleData"
            @popupClose="vehicleData = null" :addVehicle="addAccidentVehicle" :updateVehicle="updateAccidentVehicle"
            :allowUpdateRecord="allowUpdateRecord" />
        <Costs @costUpdated="getCostData" :id="accidentID" :costData="costData" @popupClose="costData = null"
            :addCost="addAccidentCost" :updateCost="updateAccidentCost" :allowUpdateRecord="allowUpdateRecord" />
        <DeleteModal v-if="showDeleteContactPopup" @confirm="deleteContactItem($event)" />
        <DeleteModal v-if="showDeleteVehiclePopup" @confirm="deleteVehicleItem($event)" />
        <DeleteModal v-if="showDeleteDocumentPopup" @confirm="deleteDocumentItem($event)"
            :message="$t('editAccident.deleteDocConfirm')" />
        <DeleteModal v-if="showDeleteCostPopup" @confirm="deleteCostItem($event)" />
        <DeleteModal v-if="showDeleteAccidentModal" @confirm="deleteAccidentItem($event)" />
        <Document v-if="accidentPayload.driver && currentAccidentData && currentAccidentData.record_no" :id="accidentID"
            :allowUpdateRecord="allowUpdateRecord" @documentsUpdated="getDocumentData" :documentItem="documentData"
            @popupClose="documentData = null" :mediaData="media" :mediaDataID="mediaID" :mediaDataType="mediaType"
            :addDoc="addAccidentDoc" :updateDoc="updateAccidentDoc" :allowVideo="true" :driver="this.driverOptions.filter(
                (item) => item.id === accidentPayload.driver
            )[0].label" :recordNo="currentAccidentData.record_no" :deleteDocItem="deleteDocumentItem" />
        <DeleteModal v-if="showActionImagePopup" @confirm="updateImgData($event)" :message="imageActionMessage"
            :removeMessage="imageActionMessage ? '' : 'Delete'" :updateMessage="!!imageActionMessage" />
        <DrawingAccident v-if="currentAccidentData && currentAccidentData.record_no"
            @getAccidentDrawing="getAccidentDrawing($event)" :drawingData="accidentPayload.drawing_data" />
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { mapActions, mapGetters } from "vuex";
import DeleteModal from "@/components/DeleteModal.vue";
import Contacts from "./Contacts";
import AccidentVehicle from "./AccidentVehicle";
import Document from './Document.vue';
import ImagesSection from "./ImagesSection.vue";
import ActivityLogs from "@/components/Shared/ActivityLogs.vue"
import { checkValueExists } from "../../services/helper";
import Notes from "../Shared/Notes";
import * as moment from "moment-timezone";
import DrawingAccident from "./DrawingAccident.vue"
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Costs from "./Costs"
import { pickerDate } from "@/services/helper";
export default {
    components: { vSelect, Contacts, DeleteModal, Document, ActivityLogs, Notes, DatePicker, AccidentVehicle, Costs, ImagesSection, DrawingAccident },
    name: "EditAccident",
    props: ['accidentID', 'initialTab'],
    computed: {
        ...mapGetters([
            "userCompany",
            "allEquipments",
            "allDrivers",
            "currentAccidentData",
            "allCountries",
            'rolePermissions',
            'divisions'
        ]),
        showActivitySection() {
            return this.rolePermissions && this.rolePermissions['Activity Log'] && this.rolePermissions['Activity Log'][0].allow
        },
        allowUpdateRecord() {
            return this.rolePermissions && this.rolePermissions['Safety'] && this.rolePermissions['Safety'][1].allow
        },
        allowDeleteRecord() {
            return this.rolePermissions && this.rolePermissions['Safety'] && this.rolePermissions['Safety'][3].allow
        },
        hasChanged() {
            return Object.keys(this.accidentPayload).filter(field => {
                if (typeof this.accidentPayload[field] === 'object') return JSON.stringify(this.accidentPayload[field]) !== JSON.stringify(this.defaultData[field])
                if (field === 'odometer' || field === 'amount') return this.checkValueExists(this.accidentPayload[field])?.toString()?.replaceAll(",", "") != this.checkValueExists(this.defaultData[field])?.toString()?.replaceAll(",", "")
                if (field === 'notes') {
                    return this.checkValueExists(this.accidentPayload[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n')) != this.checkValueExists(this.defaultData[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n'));
                }
                else return this.checkValueExists(this.accidentPayload[field]) != this.checkValueExists(this.defaultData[field])
            }).length > 0
        },
        statusOptions() {
            return [
                { value: 'New', text: this.$t('editAccident.statusNew') },
                { value: 'Open', text: this.$t('editAccident.statusOpen') },
                { value: 'Closed', text: this.$t('editAccident.statusClosed') },
                { value: 'Urgent', text: this.$t('editAccident.statusUrgent') }
            ]
        },
        yesNoOptions() {
            return [
                { value: '', text: '' },
                { value: true, text: this.$t('editAccident.yesOption') },
                { value: false, text: this.$t('editAccident.noOption') }
            ]
        },
        yesNoNullOptions() {
            return [
                { value: null, text: '-' },
                { value: false, text: this.$t('editAccident.noOption') },
                { value: true, text: this.$t('editAccident.yesOption') }
            ]
        },
        hazmatOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'Yes', text: this.$t('editAccident.yesOption') },
                { value: 'No', text: this.$t('editAccident.noOption') }
            ]
        },
        surfaceOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'Dry', text: this.$t('addAccident.surfaceDry') },
                { value: 'Wet', text: this.$t('addAccident.surfaceWet') }
            ]
        },
        weatherOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'Sunny', text: this.$t('addAccident.weatherSunny') },
                { value: 'Cloudy', text: this.$t('addAccident.weatherCloudy') },
                { value: 'Fog', text: this.$t('addAccident.weatherFog') },
                { value: 'Rain', text: this.$t('addAccident.weatherRain') },
                { value: 'Snow', text: this.$t('addAccident.weatherSnow') },
                { value: 'Wind', text: this.$t('addAccident.weatherWind') }
            ]
        },
        citationOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'No', text: this.$t('editAccident.noOption') },
                { value: 'Yes', text: this.$t('editAccident.yesOption') },
                { value: 'Other party', text: this.$t('editAccident.otherPartyOption') }
            ]
        },
        drugStatusOptions() {
            return [
                { value: '-', text: '-' },
                { value: 'Requested', text: this.$t('addAccident.drugStatusRequested') },
                { value: 'Completed', text: this.$t('addAccident.drugStatusCompleted') },
                { value: 'Results', text: this.$t('addAccident.drugStatusResults') }
            ]
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
    },
    data() {
        return {
            checkValueExists,
            errors: {},
            activeTab: "info",
            claimOptions: [],
            imageActionMessage: '',
            claimNumbers: [],
            media: null,
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            mediaType: null,
            mediaID: null,
            vehicleID: null,
            costID: null,
            contactData: null,
            vehicleData: null,
            costData: null,
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            documentData: null,
            docName: "",
            states: [],
            defaultData: {},
            currentDocumentPage: 1,
            totalAmount: 0,
            showDeleteVehiclePopup: false,
            showDeleteCostPopup: false,
            showDeleteContactPopup: false,
            showDeleteDocumentPopup: false,
            showDeleteAccidentModal: false,
            showActionImagePopup: false,
            currentContactPage: 1,
            currentVehiclePage: 1,
            costFields: [
                {
                    key: "date",
                    label: "Date",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "description",
                    label: "Description",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "amount",
                    label: "Amount",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
            contactFields: [
                {
                    key: "name",
                    label: "Name",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "role",
                    label: "Role",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "phone",
                    label: "Phone",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "email",
                    label: "Email",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "injury_status",
                    label: "Inj/Fat",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "ambulance",
                    label: "Amb.",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
            vehicleFields: [
                {
                    key: "name",
                    label: "Name",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "make",
                    label: "Make",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "type",
                    label: "Type",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "insurance",
                    label: "Insurance",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "policy_no",
                    label: "Policy #",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "tow",
                    label: "Tow",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
            accidentPayload: {
                record_no: null,
                address: "",
                alc_test_date: null,
                city: "",
                claim_number: "",
                customer: "",
                drug_test_date: null,
                hazmat_or_gas_spill: "",
                number_of_fatality: null,
                number_of_injury: null,
                number_of_vehicles: null,
                load_number: "",
                drawing_data: null,
                officer: "",
                postal_code: "",
                report_number: "",
                report_state: null,
                state: null,
                surface: "-",
                driver: null,
                weather: "-",
                status: "Closed",
                vehicle: null,
                trailer: null,
                date: null,
                time: null,
                citation_number: "",
                dot_status: null,
                fault_status: null,
                notes: "",
                officer_on_site: false,
                citation_issues: "-",
                ambulance_on_site: false,
                ambulance_name: "",
                ambulance_location: "",
                driver_treated_by_ambulance: null,
                is_fatality: null,
                towing: false,
                towing_name: "",
                towing_location: "",
                vehicle_towed: null,
                loaded_trailer: false,
                load_damaged: null,
                drug_test_status: "-",
                alc_test_status: "-",
                drug_or_alc: false,
                division: null
            },
            driverOptions: [],
            vehicleOptions: [],
            trailerOptions: [],
            contactItems: [],
            vehicleItems: [],
            documentItems: [],
            imageItems: [],
            costItems: [],
            documentFields: [
                {
                    label: "Description",
                    key: "description",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
        }
    },
    methods: {
        ...mapActions([
            "getFilteredEquipments",
            "getFilteredDrivers",
            "setLoader",
            "getAccidentData",
            "setNotification",
            "getAllCountries",
            "updateAccident",
            "getAccidentContacts",
            "getAccidentVehicles",
            "deleteAccidentContact",
            "getAccidentDocs",
            "deleteAccidentDocument",
            "addAccidentDoc",
            "updateAccidentDoc",
            "deleteAccident",
            "addAccidentContact",
            "addAccidentVehicle",
            "updateAccidentContact",
            "getAllClaims",
            "deleteAccidentVehicle",
            "updateAccidentVehicle",
            "getAccidentCosts",
            "addAccidentCost",
            "updateAccidentCost",
            "deleteAccidentCost"
        ]),
        getAccidentDrawing(payload) {
            if (payload) this.accidentPayload.drawing_data = payload
        },
        getAmount(val) {
            return parseFloat(val).toLocaleString("en", {
                useGrouping: false,
                minimumFractionDigits: 2,
            });
        },
        setActionImageData(id, message) {
            this.imageActionMessage = message
            this.showActionImagePopup = true
            this.documentID = id
        },
        async updateImgData(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    const formData = new FormData();
                    formData.append('gallery', this.imageActionMessage === 'Do you want to move this image to Images section?' ? true : false);
                    await this.updateAccidentDoc({ id: this.accidentID, docID: this.documentID, payload: formData })
                    await this.setNotification({
                        msg: this.$t('imagesSection.imagesUploaded'),
                        type: "success",
                        color: "green",
                    });
                    this.documentID = null
                    this.showActionImagePopup = false
                    this.imageActionMessage = ""
                    this.getImagesData()
                    this.getDocumentData()
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            }
            else {
                this.documentID = null
                this.showActionImagePopup = false
                this.imageActionMessage = ""
            }
        },
        async openLink(link) {
            window.open(link, "_blank");
        },
        async openDoc(data) {
            this.docName = data.name
            this.media = data.document
            this.mediaID = data.id
            if (data.document.includes('.pdf')) this.mediaType = 'pdf'
            else if (data.document.includes('.mp4') || data.document.includes('.mkv') || data.document.includes('.mov') || data.document.includes('.avi')) this.mediaType = 'video'
            else this.mediaType = 'image'
        },
        downloadDoc(data) {
            this.docName = data.name
            this.setLoader(true)
            fetch(data.document)
                .then(response => response.blob())
                .then(blob => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = `${this.docName}.${data.document.split('.').pop().split(/[#?]/)[0]}`
                    link.click();
                    link.remove()
                    this.setLoader(false)
                })
                .catch(this.setLoader(false));
        },
        setDeleteDocumentData(id) {
            this.showDeleteDocumentPopup = true
            this.documentID = id
        },
        setDocumentData(data) {
            this.documentData = data
            this.openDoc(data)
            this.$bvModal.show("modal-document");
        },
        formatTooltipText(text) {
            const maxLineLength = window.screen.width <= 767 ? 50 : 80;
            let formattedText = "";
            let lineLength = 0;

            text.split(' ').forEach(word => {
                if (lineLength + word.length + 1 > maxLineLength) {
                    formattedText += "\n";
                    lineLength = 0;
                }
                formattedText += (lineLength === 0 ? "" : " ") + word;
                lineLength += word.length + 1;
            });

            return formattedText;
        },
        async getDocumentData() {
            this.documentItems = []
            const data = await this.getAccidentDocs({ id: this.accidentID })
            data.filter((doc) => !doc.gallery).sort((a, b) => a?.description?.toLowerCase().localeCompare(b?.description?.toLowerCase())).map((item) => {
                this.documentItems.push({
                    id: item.id,
                    date: moment(item.date).format('ll'),
                    description: item.description,
                    document: item.document,
                    name: `accident-${this.currentAccidentData.record_no}-${item.description ? item.description : ''}`
                })
            })
        },
        async getImagesData() {
            this.imageItems = []
            const data = await this.getAccidentDocs({ id: this.accidentID })
            data.filter((doc) => doc.gallery).map((item) => {
                this.imageItems.push({
                    id: item.id,
                    description: item.description,
                    document: item.document,
                })
            })
        },
        async deleteDocumentItem(status, id = null) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteAccidentDocument({
                        accidentID: this.accidentID,
                        documentID: `${id ? id : this.documentID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('editAccident.docDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.getDocumentData()
                    this.documentID = null
                    this.showDeleteDocumentPopup = false
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.documentID = null
                this.showDeleteDocumentPopup = false
            }
        },

        setDeleteContactData(id) {
            this.showDeleteContactPopup = true
            this.contactID = id
        },
        setDeleteVehicleData(id) {
            this.showDeleteVehiclePopup = true
            this.vehicleID = id
        },
        setDeleteCostData(id) {
            this.showDeleteCostPopup = true
            this.costID = id
        },
        async deleteAccidentItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteAccident({
                        accidentID: `${this.accidentID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('editAccident.accidentDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.showDeleteAccidentModal = false
                    this.$emit("accidentUpdated", true)
                    this.setLoader(false)
                    this.resetPopup()
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.showDeleteAccidentModal = false
            }
        },
        async deleteContactItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteAccidentContact({
                        accidentID: this.accidentID,
                        contactID: `${this.contactID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('editAccident.contactDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.getContactData()
                    this.contactID = null
                    this.showDeleteContactPopup = false
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.contactID = null
                this.showDeleteContactPopup = false
            }
        },
        async deleteVehicleItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteAccidentVehicle({
                        accidentID: this.accidentID,
                        vehicleID: `${this.vehicleID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('editAccident.vehicleDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.getVehicleData()
                    this.vehicleID = null
                    this.showDeleteVehiclePopup = false
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.contactID = null
                this.showDeleteContactPopup = false
            }
        },
        async deleteCostItem(status) {
            if (status) {
                try {
                    this.setLoader(true)
                    await this.deleteAccidentCost({
                        accidentID: this.accidentID,
                        costID: `${this.costID}/?company_id=${this.userCompany}`
                    })
                    await this.setNotification({
                        msg: this.$t('editAccident.costDeleted'),
                        type: "success",
                        color: "green",
                    });
                    this.getCostData()
                    this.costID = null
                    this.showDeleteCostPopup = false
                    this.setLoader(false)
                }
                catch (e) {
                    this.setLoader(false)
                    console.log(e)
                }
            } else {
                this.contactID = null
                this.showDeleteContactPopup = false
            }
        },
        setContactData(data) {
            this.contactData = data
            this.$bvModal.show("modal-contact");
        },
        setVehicleData(data) {
            this.vehicleData = data
            this.$bvModal.show("modal-accident-vehicle");
        },
        setCostData(data) {
            this.costData = data
            this.$bvModal.show("modal-cost");
        },
        async onUpdateAccident() {
            try {
                const nullKeys = this.checkNullValues({
                    driver: this.accidentPayload.driver,
                    date: this.accidentPayload.date,
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true)
                    if (!this.accidentPayload.driver_treated_by_ambulance) this.accidentPayload.is_fatality = null
                    await this.updateAccident({ id: this.accidentID, payload: { ...this.accidentPayload, claim_number: this.claimNumbers.length ? this.claimNumbers.toString() : '', date: moment(this.accidentPayload.date).format('YYYY-MM-DD'), drug_test_date: this.accidentPayload.drug_test_date ? moment(this.accidentPayload.drug_test_date).format('YYYY-MM-DD') : null, alc_test_date: this.accidentPayload.alc_test_date ? moment(this.accidentPayload.alc_test_date).format('YYYY-MM-DD') : null, drawing_data: this.accidentPayload.drawing_data ? JSON.stringify(this.accidentPayload.drawing_data) : null } })
                    await this.setNotification({
                        msg: this.$t('editAccident.accidentUpdated'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$emit("accidentUpdated", true)
                    this.resetPopup()
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('safetyShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false);
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async getCountries() {
            await this.getAllCountries();
            const countries = this.allCountries.map((item) => ({
                id: item.id,
                label: item.name,
            }));
            this.getStates(countries[0]);
        },
        getStates(selectedOption) {
            this.states = this.allCountries
                .filter((country) => country.id === selectedOption.id)[0]
                .state.map((item) => ({
                    id: item.id,
                    label: item.name,
                }));
            this.accidentPayload.state = this.states.filter(
                (state) => state.label === "-"
            )[0].id;
            this.accidentPayload.report_state = this.states.filter(
                (state) => state.label === "-"
            )[0].id;
        },
        async getContactData() {
            this.contactItems = []
            const data = await this.getAccidentContacts({ id: this.accidentID })
            data.map((item) => {
                this.contactItems.push({
                    id: item.id,
                    name: item.name,
                    role: item.role,
                    phone: item.phone,
                    email: item.email,
                    injury_status: item.injury_status,
                    ambulance: item.ambulance
                })
            })
        },
        async getVehicleData() {
            this.vehicleItems = []
            const data = await this.getAccidentVehicles({ id: this.accidentID })
            data.map((item) => {
                this.vehicleItems.push({
                    id: item.id,
                    name: item.name,
                    make: item.make,
                    type: item.type,
                    insurance: item.insurance,
                    policy_no: item.policy_no,
                    tow: item.tow
                })
            })
        },
        async getCostData() {
            this.costItems = []
            const data = await this.getAccidentCosts({ id: this.accidentID })
            this.totalCostAmount = data.total_cost
            data.results.map((item) => {
                this.costItems.push({
                    id: item.id,
                    date: moment(item.date).format("ll"),
                    description: item.description,
                    amount: item.amount
                })
            })
        },
        resetPopup() {
            this.$emit("resetEditAccident", true)
        },
        async searchClaims(searchText) {
            let options = []
            const url = `sort_field=record_no&search_field=${searchText}&sort_order=desc&page=1&page_size=10`
            const data = await this.getAllClaims(url);
            data.records.forEach((x) => {
                options.push({
                    id: x.record_no.toString(),
                    label: x.record_no.toString(),
                });
            });
            this.claimOptions = this.claimOptions.concat(options)
            this.claimOptions = [...new Map(this.claimOptions.map(item => [item['id'], item])).values()]
        },
        async searchDriver(searchText) {
            if (searchText) {
                let options = []
                const driverRecords = await this.getFilteredDrivers(searchText);
                driverRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.name,
                    });
                });
                this.driverOptions = this.driverOptions.concat(options)
                this.driverOptions = [...new Map(this.driverOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchVehicle(searchText) {
            if (searchText) {
                let options = [];
                const vehicleRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Vehicle" });
                vehicleRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.vehicleOptions = this.vehicleOptions.concat(options)
                this.vehicleOptions = [...new Map(this.vehicleOptions.map(item => [item['id'], item])).values()]
            }
        },
        async searchTrailer(searchText) {
            if (searchText) {
                let options = [];
                const trailerRecords = await this.getFilteredEquipments({ unit_no: searchText, type: "Trailer" });
                trailerRecords.forEach((x) => {
                    options.push({
                        id: x.id,
                        label: x.unit_no,
                    });
                });
                this.trailerOptions = this.trailerOptions.concat(options)
                this.trailerOptions = [...new Map(this.trailerOptions.map(item => [item['id'], item])).values()]
            }
        },
    },
    watch: {
        async accidentID() {
            if (this.accidentID) {
                this.activeTab = this.initialTab || 'info'
                try {
                    this.setLoader(true)
                    this.accidentPayload = {
                        record_no: null,
                        address: "",
                        alc_test_date: null,
                        city: "",
                        claim_number: "",
                        customer: "",
                        citation_number: "",
                        drug_test_date: null,
                        hazmat_or_gas_spill: "",
                        number_of_fatality: null,
                        number_of_injury: null,
                        number_of_vehicles: null,
                        officer: "",
                        postal_code: "",
                        report_number: "",
                        report_state: null,
                        state: null,
                        load_number: "",
                        surface: "-",
                        driver: null,
                        weather: "-",
                        status: "Closed",
                        vehicle: null,
                        trailer: null,
                        date: null,
                        time: null,
                        dot_status: null,
                        fault_status: null,
                        notes: "",
                        officer_on_site: false,
                        citation_issues: "-",
                        ambulance_on_site: false,
                        ambulance_name: "",
                        ambulance_location: "",
                        driver_treated_by_ambulance: null,
                        is_fatality: null,
                        towing: false,
                        towing_name: "",
                        towing_location: "",
                        vehicle_towed: null,
                        loaded_trailer: false,
                        load_damaged: null,
                        drug_test_status: "-",
                        alc_test_status: "-",
                        drug_or_alc: false,
                        division: null
                    },
                        this.errors = {}
                    this.defaultData = {}
                    this.driverOptions = [],
                        this.vehicleOptions = [],
                        this.trailerOptions = [],
                        this.claimOptions = []
                    this.claimNumbers = []
                    await this.getCountries();
                    await this.getAccidentData(this.accidentID)
                    this.accidentPayload = {
                        record_no: this.currentAccidentData.record_no,
                        address: this.currentAccidentData.address,
                        alc_test_date: this.currentAccidentData.alc_test_date ? pickerDate(this.currentAccidentData.alc_test_date) : '',
                        city: this.currentAccidentData.city,
                        claim_number: this.currentAccidentData.claim_number,
                        customer: this.currentAccidentData.customer,
                        drug_test_date: this.currentAccidentData.drug_test_date ? pickerDate(this.currentAccidentData.drug_test_date) : '',
                        hazmat_or_gas_spill: this.currentAccidentData.hazmat_or_gas_spill,
                        number_of_fatality: this.currentAccidentData.number_of_fatality,
                        number_of_injury: this.currentAccidentData.number_of_injury,
                        number_of_vehicles: this.currentAccidentData.number_of_vehicles,
                        officer: this.currentAccidentData.officer,
                        postal_code: this.currentAccidentData.postal_code,
                        report_number: this.currentAccidentData.report_number,
                        report_state: this.currentAccidentData.report_state,
                        state: this.currentAccidentData.state,
                        drawing_data: JSON.parse(this.currentAccidentData.drawing_data),
                        surface: this.currentAccidentData.surface ? this.currentAccidentData.surface : '-',
                        load_number: this.currentAccidentData.load_number,
                        driver: this.currentAccidentData.driver,
                        weather: this.currentAccidentData.weather ? this.currentAccidentData.weather : '-',
                        status: this.currentAccidentData.status,
                        vehicle: this.currentAccidentData.vehicle,
                        trailer: this.currentAccidentData.trailer,
                        date: pickerDate(this.currentAccidentData.date),
                        time: this.currentAccidentData.time,
                        dot_status: this.currentAccidentData.dot_status,
                        fault_status: this.currentAccidentData.fault_status,
                        citation_number: this.currentAccidentData.citation_number,
                        notes: this.currentAccidentData.notes,
                        officer_on_site: this.currentAccidentData.officer_on_site,
                        citation_issues: this.currentAccidentData.citation_issues,
                        ambulance_on_site: this.currentAccidentData.ambulance_on_site,
                        ambulance_name: this.currentAccidentData.ambulance_name,
                        ambulance_location: this.currentAccidentData.ambulance_location,
                        driver_treated_by_ambulance: this.currentAccidentData.driver_treated_by_ambulance,
                        is_fatality: this.currentAccidentData.is_fatality,
                        towing: this.currentAccidentData.towing,
                        towing_name: this.currentAccidentData.towing_name,
                        towing_location: this.currentAccidentData.towing_location,
                        vehicle_towed: this.currentAccidentData.vehicle_towed,
                        loaded_trailer: this.currentAccidentData.loaded_trailer,
                        load_damaged: this.currentAccidentData.load_damaged,
                        drug_test_status: this.currentAccidentData.drug_test_status,
                        alc_test_status: this.currentAccidentData.alc_test_status,
                        drug_or_alc: this.currentAccidentData.drug_or_alc,
                        division: this.currentAccidentData.division
                    }
                    this.defaultData = JSON.parse(JSON.stringify(this.accidentPayload))
                    if (this.currentAccidentData.driver) {
                        this.driverOptions.push({
                            id: this.currentAccidentData.driver,
                            label: this.currentAccidentData.driver_name,
                        })
                    }
                    if (this.currentAccidentData.vehicle) {
                        this.vehicleOptions.push({
                            id: this.currentAccidentData.vehicle,
                            label: this.currentAccidentData.vehicle_name,
                        })
                    }
                    if (this.currentAccidentData.trailer) {
                        this.trailerOptions.push({
                            id: this.currentAccidentData.trailer,
                            label: this.currentAccidentData.trailer_name,
                        })
                    }
                    if (this.currentAccidentData.claim_number) {
                        this.claimNumbers = this.accidentPayload.claim_number ? this.accidentPayload.claim_number.split(",") : []
                        this.claimNumbers.map((opt) => {
                            this.claimOptions.push({
                                id: opt,
                                label: opt,
                            })
                        })

                    }
                    await this.getContactData()
                    await this.getVehicleData()
                    await this.getDocumentData()
                    await this.getCostData()
                    await this.getImagesData()
                    this.setLoader(false)
                }
                catch (e) {
                    console.log(e)
                    this.setLoader(false)
                }
            }
        }
    }
}
</script>